module.exports = __webpack_public_path__ + "static/media/RatherBe.0687f6b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/manager/afterSales/RatherBe.mp3
// module id = KDjT
// module chunks = 3